import { Button, createStyles, Dialog, DialogActions, DialogContent, StyledComponentProps, withStyles } from '@material-ui/core';
import { observer } from 'mobx-react';
import { Instance, types } from 'mobx-state-tree';
import * as React from 'react';
import { transl } from '../../main/transl';
import { getOmnistore } from '../../stores/Omnistore';
import { templateDialogStore } from './TemplateDialog';

const SetEmptyListDialogStore = types
	.model('SetEmptyListDialogStore', {
		show: false

	})
	.views(self => ({
		get multirepo() {
			return getOmnistore().multirepo;
		}
	}))
	.views(self => ({
		get isListAvailable() {
			return !!self.multirepo.templateRepo.allAsList.length || !self.multirepo.templateRepo.etag;
		}
	}))
	.actions(self => ({
		close() {
			self.show=false;
		},
		open(){
			self.show=true;
		}
	}))
	.actions(self => ({
		cancel() {
			self.close();
		},

		gotoListPage(){
			self.close();
			getOmnistore().locationStore.setPage('LTemplates');
			templateDialogStore.start(1);
		}
	}));

export const setEmptyListDialogStore = SetEmptyListDialogStore.create({});

@observer class _EmptyListDialog extends React.Component< {store: Instance<typeof SetEmptyListDialogStore>} & StyledComponentProps> {
	render() {
		const {classes,store} = this.props;
		if (!classes) return null; // impossible
		if (store.isListAvailable) return null; // impossible
		if (getOmnistore().locationStore.secret) return null;
		return <Dialog open={true} className={classes.root} fullWidth>
			<DialogContent className={classes.content}>{transl('location_add.step_1_0')}</DialogContent>
			<DialogActions className={classes.actions}>
				<Button color="primary" variant="contained" onClick={store.gotoListPage}>{transl('letsGo')}</Button>
			</DialogActions>
		</Dialog>;
	}
}

const styles = createStyles({
	root: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'stretch',
		'& .MuiDialog-paper':{
			padding: '60px'
		}
	},
	content: {
		display: 'flex',
		flexDirection: 'column',
		fontWeight: 'bold',
		alignItems: 'center',
		width: '100%',
		textAlign: 'center',
		padding: '30px',
		fontSize: '14px'
	},
	actions:{
		justifyContent: 'center'
	}
});

export const EmptyListDialog = withStyles(styles)(_EmptyListDialog);

